<template>
  <div class="tabBg pr">
    <ul :class="['tabChoose', show ? 'tabChoose1' : 'tabChoose2']">
      <li @click="onShow(1)" :class="['tabChoose-1', {active: show}]">电子银行承兑汇票贴现</li>
      <li @click="onShow(2)" :class="['tabChoose-2', {active: !show}]">电子商业承兑汇票贴现</li>
    </ul>

    <p class="tab-left-text">电子承兑汇票 <br> 在线办理贴现</p>

    <ul class="tabContent">
      <li v-show="show" class="tabContent-1">
        <div class="tabContent-left">
          <div class="tabContent-left-top">
            <p class="tabContent-left-top-text2 wow fadeInUp"><span class="mark">4</span>大产品优势</p>
          </div>

          <div class="tabContent-left-center wow pulse"></div>

          <p class="tabContent-left-btn tabContent-left-btn2">
            <span class="btn-left wow fadeInUp" data-wow-delay="0.3s" @click="$router.push('SilverTicketManage')"><i></i>立即开户</span>
            <span class="btn-right wow fadeInUp" data-wow-delay="0.45s" @click="$router.push('ApplicationDiscount')"><i></i>获取报价</span>
          </p>
        </div>

        <home-best-rate-trial :bestRate="bestRate"></home-best-rate-trial>
        <!-- <div class="tabContent-right wow pulse"></div> -->
      </li>
      <li v-show="!show" class="tabContent-2">
        <div class="tabContent-left">
          <div class="tabContent-left-top">
            <p class="tabContent-left-top-text1 wow fadeInUp">商业承兑汇票贴现</p>
            <p class="tabContent-left-top-text2 wow fadeInUp" data-wow-delay="0.15s">便捷流通、节省成本、增强效率、提高信用</p>
          </div>

          <div class="tabContent-left-center wow pulse"></div>

          <p class="tabContent-left-btn">
            <span class="btn-left wow fadeInUp" data-wow-delay="0.3s" @click="$router.push('AccountManage')"><i></i>立即开户</span>
            <span class="btn-right wow fadeInUp" data-wow-delay="0.45s" @click="$router.push('BusinessTicketDiscount')"><i></i>获取报价</span>
          </p>
        </div>
        <div class="tabContent-right wow pulse"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import HomeBestRateTrial from './HomeBestRateTrial'
export default {
  components: {
    HomeBestRateTrial
  },
  props: ['bestRate'],
  data () {
    return {
      show: true
    }
  },
  methods: {
    onShow (val) {
      if (val == 1 && this.show) {
        return false;
      }
      if (val == 2 && !this.show) {
        return false;
      }
      this.show = !this.show;
      if (!this.isIE()) {
        new this.WOW().init();
      }
    }
  },
  mounted () {
    if (!this.isIE()) {
      new this.WOW().init();
    }
  }
}
</script>

<style lang="less">
ul {
  list-style: none;
}

.tab-left-text {
  font-weight: 700;
  text-shadow: 2px -2px 7px rgb(155, 115, 92, 0.8);
  color: #fff;
  letter-spacing: 1px;
  position: absolute;
  top: 18px;
  left: 21px;
  width: 186px;
  line-height: 29px;
  text-align: center;
  font-size: 23px;
  word-wrap: break-word;
}
.tabBg {
  width: 1190px;
  height: 480px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background-color: #fff;
  margin-top: 55px;
  position: relative;
  box-shadow: 4px 2px 13px 0px rgba(99, 99, 99, 0.5);

  .tabChoose {
    width: 252px;
    height: 510px;
    margin-top: -30px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: left top;
    padding-left: 19px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    &.tabChoose1 {
      background-image: url('~@/assets/img/home/tab/dzcdhp.png');
    }
    &.tabChoose2 {
      background-image: url('~@/assets/img/home/tab/dzcdhpb.png');
    }

    > li {
      width: 233px;
      height: 192px;
      color: #7384c4;
      font-size: 18px;
      cursor: pointer;
      padding-left: 24px;
      box-sizing: border-box;
      line-height: 30px;
      display: flex;
      align-items: center;

      &:not(.active):hover {
        color: #fff;
      }
      &.tabChoose-2 {
        padding-bottom: 36px;
      }

      &.active {
        color: #333;
        font-weight: 700;

        // 三角形
        &:after {
          width: 0;
          height: 0;
          display: inline-block;
          content: '';
          border-left: 6px solid #171717;
          border-top: 6px solid transparent;
          border-bottom: 6px solid transparent;
          margin-left: 9px;
        }
      }
    }
  }
  .tabContent {
    height: 100%;

    .tabContent-1,
    .tabContent-2 {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      box-sizing: border-box;

      .tabContent-left {
        .tabContent-left-top {
          font-weight: bold;
          height: 100px;
          background: url('~@/assets/img/home/tab/box.png') no-repeat left top;
          background-size: contain;
          padding: 32px 0px 0px 32px;

          .tabContent-left-top-text1 {
            font-size: 18px;
            color: #ff0000;
          }
          .tabContent-left-top-text2 {
            font-size: 24px;
            color: #333;
            white-space: nowrap;
          }
        }

        .tabContent-left-center {
          width: 459px;
          height: 110px;
          margin-top: 30px;
        }
        .tabContent-left-btn {
          margin-top: 76px;
          display: flex;
          justify-content: center;
          align-items: center;

          .btn-left {
            display: inline-block;
            width: 205px;
            height: 46px;
            cursor: pointer;
            background: linear-gradient(42deg, #e12e32, #ff4800);
            border-radius: 2px;
            font-weight: bold;
            color: #fff;
            line-height: 46px;
            font-size: 14px;
            text-align: center;
            margin-right: 40px;

            i {
              display: inline-block;
              width: 0px;
              height: 0px;
              border-left: 9px solid #fff;
              border-top: 5.5px solid transparent;
              border-bottom: 5.5px solid transparent;
              vertical-align: -1px;
              margin-right: 17px;
            }

            &:hover {
              opacity: 0.6;
              box-shadow: 0px 9px 15px 1px rgba(255, 11, 17, 0.4);
            }
          }
          .btn-right {
            display: inline-block;
            width: 205px;
            height: 46px;
            cursor: pointer;
            background: rgba(0, 119, 218, 0);
            border: 1px solid #e1241a;
            border-radius: 2px;
            font-weight: bold;
            color: #e1241a;
            line-height: 46px;
            font-size: 14px;
            text-align: center;

            i {
              display: inline-block;
              width: 13px;
              height: 13px;
              background: url('~@/assets/img/home/tab/icon_yuan.png') no-repeat
                center center;
              vertical-align: -1px;
              margin-right: 13px;
            }

            &:hover {
              opacity: 0.6;
            }
          }
        }
        .tabContent-left-btn2 {
          justify-content: flex-start;
          margin-top: 43px;
          .btn-left {
            width: 154px;
            height: 46px;
            margin-right: 0;
            position: relative;
            background: url(~@/assets/img/home/tab/Discount_now_n_b.png)
              no-repeat center left;
            &:hover {
              box-shadow: none;
            }
          }
          .btn-right {
            width: 154px;
            height: 46px;
            background: url(~@/assets/img/home/tab/Discount_now_n_a.png)
              no-repeat center left;
            border: none;
          }
        }
      }

      .tabContent-right {
        width: 371px;
        height: 388px;
      }
    }

    .tabContent-1 {
      padding-left: 19px;

      .tabContent-left {
        width: 500px;
        // 顶部标题
        .tabContent-left-top {
          font-weight: bold;
          height: 36px;
          background: url('~@/assets/img/home/tab/box_path.png') no-repeat left
            top;
          background-size: contain;
          padding: 0;

          .tabContent-left-top-text2 {
            font-size: 20px;
            span {
              display: inline-block;
              width: 32px;
              text-align: center;
              font-size: 28px;
            }
          }
        }

        .tabContent-left-center {
          margin-top: 13px;
          width: 483px;
          height: 246px;
          background: url('~@/assets/img/home/tab/bg_photo.png') no-repeat
            center center;
        }
      }
      .tabContent-right {
        background: url('~@/assets/img/home/tab/yinhang.png') no-repeat center
          center;
      }
    }

    .tabContent-2 {
      padding: 0px 22px 0px 19px;
      background: url('~@/assets/img/home/tab/bg_Graphics.png') no-repeat right
        bottom;

      .tabContent-left {
        .tabContent-left-center {
          background: url('~@/assets/img/home/tab/f_b1.png') no-repeat center
            center;
        }
      }

      .tabContent-right {
        background: url('~@/assets/img/home/tab/shangye.png') no-repeat center
          center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/tab-ticket.vue